
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'indexInformation',
  props: {
    pageStr: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {}
  },
})
